import apiClient from "../authentication/utils/core/axios";

/**
 * Get open-close stock data for a specific symbol and date
 */
export const getPolygonStockData = async (symbol, date) => {
  const formattedDate = date || new Date().toISOString().split('T')[0];
  const response = await apiClient.get(`/open-close/${symbol}/${formattedDate}?adjusted=true`);
  if (response.status !== 200) throw new Error('Failed to fetch open-close stock data');
  return response.data;
};

/**
 * Get dividends for a ticker
 */
export const getDividendsData = async (ticker) => {
  const response = await apiClient.get(`/dividends/${ticker}`);
  if (response.status !== 200) throw new Error('Failed to fetch dividends data');
  return response.data;
};

/**
 * Get financials
 */
export const getFinancialsData = async (ticker, limit = 10) => {
  if (!ticker) throw new Error("Ticker is required for financials request");

  const response = await apiClient.get(
    `/financials?ticker=${encodeURIComponent(ticker)}&limit=${limit}`
  );

  if (response.status !== 200) throw new Error("Failed to fetch financials data");
  return response.data;
};


/**
 * Get related companies
 */
export const getRelatedCompaniesData = async (ticker) => {
  const response = await apiClient.get(`/related_companies/${ticker}`);
  if (response.status !== 200) throw new Error('Failed to fetch related companies');
  return response.data;
};

/**
 * Get ticker details
 */
export const getTickerDetailsData = async (ticker) => {
  const response = await apiClient.get(`/ticker_details/${ticker}`);
  if (response.status !== 200) throw new Error('Failed to fetch ticker details');
  return response.data;
};

/**
 * Get ticker events
 */
export const getTickerEventsData = async (id) => {
  const response = await apiClient.get(`/ticker_events/${id}`);
  if (response.status !== 200) throw new Error('Failed to fetch ticker events');
  return response.data;
};
